import { httpClient } from '@/core/httpClient/httpClient';
import { getAppSetting } from '@/core/settings/appSettings';
import { getMarket, getPlatform } from '@/core/settings/utils';
import type {
  DeliveryOffer,
  DeliveryQueryParams,
} from '@/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';
import { parseOffetTime } from '@/productDiscovery/ProductPage/common/modules/Delivery/Utils/parseOffetTime';

export const postProductsDeliveryEstimate = (
  queryParams: DeliveryQueryParams,
): Promise<DeliveryOffer[]> =>
  httpClient
    .post(
      `/api/v1/products-delivery/estimate`,
      {
        market: getMarket().toUpperCase(),
        platform: getPlatform().toUpperCase(),
        is_mf: queryParams.isManoFulfillment,
        products: [
          {
            id: queryParams.productId,
            seller_id: queryParams.sellerId,
            sku: queryParams.sku,
            quantity: queryParams.quantity,
            unit_price: queryParams.unitPrice,
            discounted: queryParams.discounted,
            weight: queryParams.weight * 1000,
          },
        ],
      },
      {
        baseURL: getAppSetting('MS_API_URL'),
        auth: { username: 'spartacux--product-page', password: '' },
        headers: {
          'x-mm-user-agent': 'spartacux--product-page',
        },
      },
    )
    .then((res: any): DeliveryOffer[] =>
      res.data.content.delivery_offers.map(
        (carrier: any): DeliveryOffer => ({
          name: carrier.name,
          type: carrier.mode,
          countries: carrier.deliverable_countries || [],
          minDeliveryTime: carrier.estimated_delivery.delivery_time.min,
          maxDeliveryTime: carrier.estimated_delivery.delivery_time.max,
          orderBefore: parseOffetTime(
            carrier.estimated_delivery.delivery_time.order_before,
          ),
          deliveryPrice: carrier.estimated_delivery.price,
          isExpress: carrier.estimated_delivery.is_express,
          isBestDeliveryOffer:
            carrier.estimated_delivery.is_best_delivery_offer,
          expressMode: carrier.estimated_delivery.delivery_time.express_mode,
        }),
      ),
    );
